import { motion } from "framer-motion";

export default function Navbar() {
  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-5 md:px-12 mix-blend-difference"
    >
      <a
        href="#top"
        data-testid="navbar-logo"
        className="font-serif-display text-xl tracking-tight text-white"
      >
        Boardroom<sup className="font-mono-label text-[9px] ml-1">®</sup>
      </a>
      <a
        href="/app"
        data-testid="navbar-open-app-link"
        className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[#0E0D0B] bg-[#C9B896] rounded-full px-5 py-2.5 hover:bg-white transition-colors duration-300"
      >
        Open App
      </a>
    </motion.header>
  );
}
